var map = {
	"./favicon/logo": 39,
	"./favicon/logo.png": 39,
	"./favicon/safari-pinned-tab": 40,
	"./favicon/safari-pinned-tab.svg": 40,
	"./placeholder/placeholder-16x9": 41,
	"./placeholder/placeholder-16x9.jpg": 41,
	"./placeholder/placeholder-1x1": 42,
	"./placeholder/placeholder-1x1.jpg": 42,
	"./placeholder/placeholder-2x1": 43,
	"./placeholder/placeholder-2x1.jpg": 43,
	"./placeholder/placeholder-2x3": 44,
	"./placeholder/placeholder-2x3.jpg": 44,
	"./placeholder/placeholder-32x9": 45,
	"./placeholder/placeholder-32x9.jpg": 45,
	"./placeholder/placeholder-3x2": 46,
	"./placeholder/placeholder-3x2.jpg": 46,
	"./placeholder/placeholder-3x4": 47,
	"./placeholder/placeholder-3x4.jpg": 47,
	"./placeholder/placeholder-8x9": 48,
	"./placeholder/placeholder-8x9.jpg": 48,
	"./schema/logo": 49,
	"./schema/logo.png": 49,
	"./social_sharing/facebook": 50,
	"./social_sharing/facebook.png": 50,
	"./social_sharing/twitter": 51,
	"./social_sharing/twitter.png": 51,
	"./template/arrow-down": 14,
	"./template/arrow-down.png": 14,
	"./template/arrow-down.svg": 129,
	"./template/arrow-left": 15,
	"./template/arrow-left.png": 15,
	"./template/arrow-left.svg": 130,
	"./template/arrow-right": 16,
	"./template/arrow-right.png": 16,
	"./template/arrow-right.svg": 131,
	"./template/arrow-up": 17,
	"./template/arrow-up.png": 17,
	"./template/arrow-up.svg": 132,
	"./template/download": 18,
	"./template/download.png": 18,
	"./template/download.svg": 133,
	"./template/email": 52,
	"./template/email.svg": 52,
	"./template/footer-logo": 53,
	"./template/footer-logo.svg": 53,
	"./template/icon--download": 54,
	"./template/icon--download.svg": 54,
	"./template/icon--link-external": 55,
	"./template/icon--link-external.svg": 55,
	"./template/icon--link-internal": 56,
	"./template/icon--link-internal.svg": 56,
	"./template/icon--map-marker_smaller": 57,
	"./template/icon--map-marker_smaller.svg": 57,
	"./template/logo": 58,
	"./template/logo.svg": 58,
	"./template/logos/air-force": 59,
	"./template/logos/air-force.png": 59,
	"./template/logos/arnold-clark": 60,
	"./template/logos/arnold-clark.png": 60,
	"./template/logos/barnsley-fc": 61,
	"./template/logos/barnsley-fc.png": 61,
	"./template/logos/first-coach": 62,
	"./template/logos/first-coach.png": 62,
	"./template/logos/placeholder-logo-square": 63,
	"./template/logos/placeholder-logo-square.png": 63,
	"./template/logos/placeholder-logo-tall": 64,
	"./template/logos/placeholder-logo-tall.png": 64,
	"./template/logos/placeholder-logo-wide": 65,
	"./template/logos/placeholder-logo-wide.png": 65,
	"./template/logos/tata-steel": 66,
	"./template/logos/tata-steel.png": 66,
	"./template/logos/thomas-cook": 67,
	"./template/logos/thomas-cook.png": 67,
	"./template/map-pin": 68,
	"./template/map-pin.png": 68,
	"./template/placeholder": 69,
	"./template/placeholder.png": 69,
	"./template/roofcare-ambient-poster-image": 70,
	"./template/roofcare-ambient-poster-image.jpg": 70,
	"./template/search": 71,
	"./template/search.svg": 71,
	"./template/select-arrow-down": 19,
	"./template/select-arrow-down-white": 72,
	"./template/select-arrow-down-white.svg": 72,
	"./template/select-arrow-down.png": 19,
	"./template/select-arrow-down.svg": 134,
	"./template/sharmans": 73,
	"./template/sharmans.svg": 73,
	"./template/tick": 20,
	"./template/tick.png": 20,
	"./template/tick.svg": 135,
	"./template/video-modal-widget-bg": 74,
	"./template/video-modal-widget-bg.png": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;